import SkeletonWave from '../../../../components/ui/skeleton/SkeletonWave';
import styled from 'styled-components';

interface BoxProps {
  mt?: number;
  mb?: number;
  ml?: number;
  mr?: number;
}

const RightSideSkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

const Box = styled.div<BoxProps>`
  ${(props) => (props.mt ? `margin-top: ${props.mt}px;` : '')}
  ${(props) => (props.mb ? `margin-bottom: ${props.mb}px;` : '')}
  ${(props) => (props.ml ? `margin-left: ${props.ml}px;` : '')}
  ${(props) => (props.mr ? `margin-right: ${props.mr}px;` : '')}
`;

const RectangleWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
`;

type RightSideSkeletonProps = {
  isMobileWidth: boolean;
};

const RightSideSkeleton = ({ isMobileWidth }: RightSideSkeletonProps) => {
  return (
    <RightSideSkeletonWrapper>
      <Box mb={15}>
        <SkeletonWave
          width={isMobileWidth ? 'auto' : 200}
          height={25}
          backgroundColor="#224"
        />
      </Box>
      <Box mb={10}>
        <SkeletonWave
          width={isMobileWidth ? 'auto' : 180}
          height={10}
          backgroundColor="#224"
        />
      </Box>
      <Box mb={10}>
        <SkeletonWave
          width={isMobileWidth ? 'auto' : 180}
          height={10}
          backgroundColor="#224"
        />
      </Box>
      <Box mb={10}>
        <SkeletonWave
          width={isMobileWidth ? 'auto' : 180}
          height={10}
          backgroundColor="#224"
        />
      </Box>
      <RectangleWrapper>
        <Box mr={10}>
          <SkeletonWave
            width={isMobileWidth ? 'auto' : 30}
            height={30}
            backgroundColor="#224"
          />
        </Box>
        <Box mr={10}>
          <SkeletonWave
            width={isMobileWidth ? 'auto' : 30}
            height={30}
            backgroundColor="#224"
          />
        </Box>
        <Box mr={10}>
          <SkeletonWave
            width={isMobileWidth ? 'auto' : 30}
            height={30}
            backgroundColor="#224"
          />
        </Box>
      </RectangleWrapper>
      <Box mt={30}>
        <SkeletonWave
          width={isMobileWidth ? 'auto' : 400}
          height={10}
          backgroundColor="#224"
        />
      </Box>
      <Box mt={10}>
        <SkeletonWave
          width={isMobileWidth ? 'auto' : 400}
          height={10}
          backgroundColor="#224"
        />
      </Box>
      <Box mt={10}>
        <SkeletonWave
          width={isMobileWidth ? 'auto' : 400}
          height={10}
          backgroundColor="#224"
        />
      </Box>
      <Box mt={10}>
        <SkeletonWave
          width={isMobileWidth ? 'auto' : 400}
          height={10}
          backgroundColor="#224"
        />
      </Box>
      <Box mt={10}>
        <SkeletonWave
          width={isMobileWidth ? 'auto' : 400}
          height={10}
          backgroundColor="#224"
        />
      </Box>
      <Box mt={20}>
        <SkeletonWave
          width={isMobileWidth ? 'auto' : 400}
          height={10}
          backgroundColor="#224"
        />
      </Box>
      <Box mt={10}>
        <SkeletonWave
          width={isMobileWidth ? 'auto' : 400}
          height={10}
          backgroundColor="#224"
        />
      </Box>
    </RightSideSkeletonWrapper>
  );
};

export default RightSideSkeleton;
